import { createRouter, createWebHistory, /*createWebHashHistory*/ } from 'vue-router';

import LoginView from '@/LoginView.vue';
import DashboardView from '@/DashboardView.vue'

import Home from '@/components/Home.vue';
import Dashboard from '@/components/Dashboard.vue';
import QualitaFirmatari from '@/pages/QualitaFirmatari.vue';

//// Mirco ////
import ViewMindTab from '@/pages/ask/MindTab.vue'
import ViewAgentiDetail from '@/pages/ask/details/AgentiDetail.vue'
import ViewClientiDetail from '@/pages/ask/details/ClientiDetail.vue'
import ViewFattureClientiDetail from '@/pages/ask/details/FattureClientiDetail.vue'
import ViewFattureAcquistoDetail from '@/pages/ask/details/FattureAcquistoDetail.vue'
import FattureScaduteOneYear from '@/pages/FattureScaduteOneYear.vue'
import ViewFornitoriDetail from '@/pages/ask/details/FornitoriDetail.vue'
import ViewContrattiVenditaDetail from '@/pages/ask/details/ContrattiVenditaDetail.vue'
import ViewListiniDetail from '@/pages/ask/details/ListiniDetail.vue'
import ViewPdrsDetail from '@/pages/ask/details/PdrsDetail.vue'
import ViewPodsDetail from '@/pages/ask/details/PodsDetail.vue'
import ViewRappresentantiDetail from '@/pages/ask/details/RappresentantiDetail.vue'

import ViewRidFattureClientiInScadenza from '@/pages/RidFattureClientiInScadenza.vue'
import ViewSdiFattureClienti from '@/pages/SdiFattureClienti.vue'
import ViewGeneraFattureClientiEnergia from '@/pages/GeneraFattureClientiEnergia.vue'
import ViewGeneraFattureClientiGas from '@/pages/GeneraFattureClientiGas.vue'

import ViewAnomalieContrattiVendita from '@/pages/AnomalieContrattiVendita.vue'

import ViewTesoreriaStatisticheAgyo from '@/pages/tesoreria/StatisticheAgyo.vue'
import ViewControlloFattureAcquisto from '@/pages/ControlloFattureAcquisto.vue'

import ViewTesoreriaBilancioSaldi from '@/pages/tesoreria/BilancioSaldi.vue'
import ViewTesoreriaCodiciIva from '@/pages/tesoreria/CodiciIva.vue'
import ViewAskBancheECodiciConto from '@/pages/tesoreria/BancheECodiciConto.vue'
import ViewAskFornitoriContiAcquisto from '@/pages/tesoreria/FornitoriContiAcquisto.vue'
import ViewAskFornitoriBollo from '@/pages/tesoreria/Bollo.vue'
import ViewMindtabFornitori from '@/pages/tesoreria/MindtabFornitori.vue'
import ViewAskElencoModuliRid from '@/pages/ElencoModuliRid.vue'



import ViewDilazioniAll from '@/pages/Dilazioni.vue'

import ViewSollecitiAll from '@/pages/Solleciti.vue'
import ViewPreavvisiAll from '@/pages/Preavvisi.vue'
// import ViewMessaInMoraAll from '@/pages/MessaInMora.vue'

//// Piero ////
import Fatture from '@/pages/Fatture.vue'
import FattureVendita from '@/pages/FattureVendita.vue'
import GestisciSolleciti from '@/pages/GestisciSolleciti.vue'
import FattureScadute from '@/pages/FattureScadute.vue'
import BilancioFattureAcquisto from '@/pages/BilancioFattureAcquisto.vue'
import FornitoriDogane from '@/pages/FornitoriDogane.vue'
import ControlloDogane from '@/pages/ControlloDogane.vue'
import InviiTelematiciDogane from '@/pages/InviiTelematiciDogane.vue'
import BilancioFattureFornitori from '@/pages/BilancioFattureFornitori.vue'
import ControlloFattureFornitoriEE from '@/pages/ControlloFattureFornitoriEE'
import ControlloFattureFornitoriGAS from '@/pages/ControlloFattureFornitoriGAS'
import ControlloAcquistatoVenduto from '@/pages/ControlloAcquistatoVenduto'
import AnalisiFornitori from '@/pages/AnalisiFornitori'
import Cmor from '@/pages/Cmor'
import CmorInvio from '@/pages/CmorInvio'
import CmorGiornaliere from '@/pages/CmorGiornaliere'
import ClientiInUscita from '@/pages/ClientiInUscita'
import PreavvisiInvio from '@/pages/PreavvisiInvio'
import PreavvisiSospSolleciti from '@/pages/PreavvisiSospSolleciti'
import Pun from '@/pages/Pun.vue'
import TariffeEe from '@/pages/TariffeEe.vue'
import TariffeGas from '@/pages/TariffeGas.vue'
import FatturaVoci from '@/pages/FatturaVoci.vue'
import BonusBasilicata from '@/pages/BonusBasilicata.vue'
import EstrattiConto from '@/pages/EstrattiConto.vue'
import ControlliEstrattoBanca from '@/pages/ControlliEstrattoBanca.vue'
import ControlloPagamenti from '@/pages/ControlloPagamenti.vue'
import EstrattiContoDetailUnregularized from '@/components/pratiche/estratticonto/details/unregularized/EstrattiContoDetail.vue'
import EstrattiContoDetailRegularized from '@/components/pratiche/estratticonto/details/regularized/EstrattiContoDetail.vue'
import EstrattiContoDetailNoteUnregularized from '@/components/pratiche/estratticonto/detailsNote/unregularized/EstrattiContoDetail.vue'
// import EstrattiContoDetailNoteRegularized from '@/components/pratiche/estratticonto/detailsNote/regularized/EstrattiContoDetail.vue'
import EstrattiContoPrevNext from '@/components/pratiche/estratticonto/details/PrevNextDetail.vue'
import GestioneMovimentiIgnoti from '@/pages/GestioneMovimentiIgnoti.vue'
import OperazioniMassive from '@/pages/Massive.vue'
import PrevisionaleDispacciamento from '@/pages/PrevisionaleDispacciamento.vue'
import PrevisionaleIncassi from '@/pages/PrevisionaleIncassi.vue'
import PrevisionaleUscite from '@/pages/PrevisionaleUscite.vue'
// import Bilancio from '@/pages/Bilancio.vue'
import BonusSociale from '@/pages/BonusSociale.vue'
import CostiPratiche from '@/pages/CostiPratiche.vue'
import PrezzoAcquisto from '@/pages/PrezzoAcquisto.vue'
import CheckRecessi from '@/pages/CheckRecessi.vue'
import AutoLettura from '@/pages/AutoLettura.vue'
import Switchin from '@/pages/Switchin.vue'
import SwitchinCaricati from '@/pages/SwitchinCaricati.vue'
import Switchout from '@/pages/Switchout.vue'
import Previsionale from '@/pages/Previsionale.vue'
import swoutCredito from '@/pages/swoutCredito.vue'
import ReportPod from '@/pages/ReportPod.vue'
import AndamentoCab from '@/pages/AndamentoCab.vue'
import InfoTicket from '@/pages/InfoTicket.vue'
import RichiestaFerie from '@/pages/RichiestaFerie.vue'
import PannelloFunzionalita from '@/pages/PannelloFunzionalita.vue'
import Documentazione from '@/pages/Documentazione.vue'
import ControlloConsumi from '@/pages/ControlloConsumi.vue'
// import ControlloRid from '@/pages/ControlloRid.vue'
import ControlloStorniRid from '@/pages/ControlloStorniRid.vue'
import Incall from '@/pages/Incall.vue';
import RecuperoCredito from '../pages/RecuperoCredito.vue';
import RiepilogoMensileRid from '@/pages/RiepilogoMensileRid.vue'
import RiepilogoGettoni from '@/pages/RiepilogoGettoni.vue'
import RiepilogoMensileInsoluti from '@/pages/RiepilogoMensileInsoluti.vue'
import RiepilogoInsolutiAgenti from '@/pages/RiepilogoInsolutiAgenti.vue'
import RiepilogoPagamenti from '@/pages/RiepilogoPagamenti.vue'
import RiepilogoProvvigioni from '@/pages/RiepilogoProvvigioni.vue'
import ControlloVociFattura from '@/pages/ControlloVociFattura.vue'
import ControlloNoteCredito from '@/pages/ControlloNoteCredito.vue'
import AndamentoAgenti from '@/pages/AndamentoAgenti.vue'
import NonSospendibili from '../components/pratiche/sospensioni/NonSospendibili.vue'
import Contabili from '@/pages/Contabili.vue'
import CreditiUsciti from '@/pages/CreditiUsciti.vue'
import InfoPraticheDossier from '@/pages/InfoPraticheDossier.vue'
import InfoCodiciConto from '@/pages/InfoCodiciConto.vue'
import RidSddAllianz from '@/pages/RidSddAllianz.vue'
import RidSddBanche from '@/pages/RidSddBanche.vue'
import InfoRichiestaRimborsi from '@/pages/InfoRichiestaRimborsi.vue'
import PreviewFatturato from '@/pages/PreviewInvoice.vue'
import PreviewSospensioniRiattivazioni from '@/pages/PreviewSospensioniRiattivazioni.vue'
import PreviewRilascioTutela from '../pages/PreviewRilascioTutela.vue';
import SospensioniRiattivazioni from '@/pages/SospensioniRiattivazioni.vue'
import InfoCiclo from '@/pages/InfoCiclo.vue'
import Fatturazione from '@/pages/Fatturazione.vue'
import FatturazioneView from '@/pages/FatturazioneView.vue'
import FatturazioneGas from '@/pages/FatturazioneGas.vue'
import Previewfatture from '../components/fatturazione/Previewfatture.vue';
import ValidazioneFatture from '../components/fatturazione/ValidazioneFatture.vue';
import CheckNonFatturati from '@/pages/CheckNonFatturati.vue'
import InfoFatturazione from '@/pages/InfoFatturazione.vue'
import FatturazioneExtra from '@/pages/FatturazioneExtra.vue'
import GestioneDepositi from '@/pages/GestioneDepositi.vue'
import InfoValidazioneCredito from '@/pages/InfoValidazioneCredito.vue'
import InfoCreditoDaGestire from '@/pages/InfoCreditoDaGestire.vue'
import InfoCreditoDaGestireBusiness from '@/components/ask/pages/InfoCreditoDaGestireBusiness.vue'
import CreditoView from '@/pages/CreditoView.vue'
import Tickets from '@/pages/Tickets.vue'
import Impostazioni from '@/pages/Settings.vue'
import Ftp from '@/pages/Ftp.vue'
import Permessi from '@/pages/Permessi.vue'
import GestionePratiche from '@/pages/GestionePratiche.vue'
import GestionePreventiviPratiche from '@/pages/GestionePreventiviPratiche.vue'
import InvioPDC from '@/pages/InvioPDC.vue'
import StatistichePDC from '@/pages/gestione-pdc/StatistichePDC.vue'
import FixPDC from '@/pages/gestione-pdc/FixPDC.vue'
import Cessazione from '@/components/pratiche/gestione-pratiche/Cessazione.vue'
import ModificaMc1 from '@/components/pratiche/gestione-pratiche/ModificaMc1.vue'
import ModificaPosaContatore from '@/components/pratiche/gestione-pratiche/ModificaPosaContatore.vue'
import PraticaVoltura from '@/components/pratiche/gestione-pratiche/PraticaVoltura.vue'
import PraticaSubentro from '@/components/pratiche/gestione-pratiche/PraticaSubentro.vue'
import PraticaVT4 from '@/components/pratiche/gestione-pratiche/PraticaVT4.vue'
import logPratiche from '@/components/pratiche/gestione-pratiche/logPratiche.vue'

import RcuCheck from '@/pages/RcuCheck.vue'


const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginView,
    },
    {
        path: '/',
        component: DashboardView,
        redirect: '/home',
        children: [
          {
            path: '/home',
            name: 'Home',
            component: Home,
            beforeEnter: [hasProfiles],
            meta: { 
              title: 'HOME',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'validazione','fatturazione_light','credito_light','assistenza_clienti']
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: [hasProfiles],
            meta: { 
              profiles:['all', 'dashboard']
            },
        },
        {
            path: '/qualitaFirmatari',
            name: 'QualitaFirmatari',
            component: QualitaFirmatari,
            beforeEnter: [hasProfiles],
            meta: { 
              profiles:['all']
            },
        },
        {
            path: '/ask/mind-tab',
            name: 'AskMindTab',
            component: ViewMindTab,
            beforeEnter: [hasProfiles],
            meta: { 
              title: 'MIND-TAB',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
            }
        },
        {
          path: '/ask/agenti/:id/dettagli',
          name: 'AskAgentiDettagli',
          component: ViewAgentiDetail,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'AGENTE',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
          }
      },
        {
            path: '/ask/clienti/:id/dettagli',
            name: 'AskClientiDettagli',
            component: ViewClientiDetail,
            beforeEnter: [hasProfiles],           
            meta: { 
              title: 'CLIENTE',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'credito_light', 'assistenza_clienti']
            }
        },
        {
            path: '/ask/clienti/fatture/:numero/dettagli',
            name: 'AskFattureClientiDettagli',
            component: ViewFattureClientiDetail,
            beforeEnter: [hasProfiles],           
            meta: { 
              title: 'FATTURA',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'credito_light', 'assistenza_clienti'] 
            }
        },
        {
          path: '/ask/acquisto/fatture/:id/dettagli',
          name: 'AskFattureAcquistoDettagli',
          component: ViewFattureAcquistoDetail,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'FATTURA ACQUISTO',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'] 
          }
      },
        {
          path: '/ask/contratti/vendita/anomalie',
          name: 'AskContrattiVenditaAnomalie',
          component: ViewAnomalieContrattiVendita,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTRATTI VENDITA ANOMALIE',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
           }
        },
        {
            path: '/ask/contratti/vendita/:id/dettagli',
            name: 'AskContrattiVenditaDettagli',
            component: ViewContrattiVenditaDetail,beforeEnter: [hasProfiles],           
            meta: { 
              title: 'CONTRATTO',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
            }
        },
        {
            path: '/ask/fornitori/:id/dettagli',
            name: 'AskFornitoriDettagli',
            component: ViewFornitoriDetail,
            beforeEnter: [hasProfiles],           
            meta: { 
              title: 'FORNITORE',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
            }
        },
        {
            path: '/ask/offerte/listini/:id/dettagli',
            name: 'AskListiniDettagli',
            component: ViewListiniDetail,beforeEnter: [hasProfiles],           
            meta: { 
              title: 'LISTINO',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
            }
        },
        {
            path: '/ask/pdrs/:id/dettagli',
            name: 'AskPdrsDettagli',
            component: ViewPdrsDetail,beforeEnter: [hasProfiles],           
            meta: { 
              title: 'PDR',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'credito_light', 'assistenza_clienti']
             }
        },
        {
            path: '/ask/pods/:id/dettagli',
            name: 'AskPodsDettagli',
            component: ViewPodsDetail,beforeEnter: [hasProfiles],           
            meta: { 
              title: 'POD',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'credito_light', 'assistenza_clienti']
            }
        },
        {
            path: '/ask/rappresentanti/:id/dettagli',
            name: 'AskRappresentantiDettagli',
            component: ViewRappresentantiDetail,
            beforeEnter: [hasProfiles],           
            meta: { 
              title: 'RAPPRESENTANTE',
              profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
             }
        },
        {
          path: '/clienti/fatture/rid/in-scadenza',
          name: 'AskRidFattureClientiInScadenza',
          component: ViewRidFattureClientiInScadenza,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RID IN SCADENZA',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'movimenti', 'acquisto', 'vendita', 'controllo']
          }
        },
        {
          path: '/clienti/fatture/sdi',
          name: 'AskSdiFattureClienti',
          component: ViewSdiFattureClienti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURE SDI',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'movimenti', 'acquisto', 'vendita', 'controllo']
          }
        },
        {
          path: '/clienti/fatture/energia/genera',
          name: 'AskGeneraFattureClientiEnergia',
          component: ViewGeneraFattureClientiEnergia,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'GENERA FATTURE EE',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'movimenti', 'acquisto', 'vendita', 'controllo']
          }
        },
        {
          path: '/clienti/fatture/gas/genera',
          name: 'AskGeneraFattureClientiGas',
          component: ViewGeneraFattureClientiGas,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'GENERA FATTURE GAS',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'movimenti', 'acquisto', 'vendita', 'controllo'] 
          }
        },
        {
          path: '/clienti/dilazioni',
          name: 'AskDilazioniAll',
          component: ViewDilazioniAll,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'DILAZIONI',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
          }
        },
        {
          path: '/controlla/dilazioni',
          name: 'ControllaDilazioni',
          component: ControllaDilazioni,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'DILAZIONI',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
          }
        },
        {
          path: '/clienti/solleciti',
          name: 'AskSollecitiAll',
          component: ViewSollecitiAll,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'SOLLECITI',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
          }
        },
        {
          path: '/clienti/preavvisi',
          name: 'AskPreavvisiAll',
          component: ViewPreavvisiAll,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREAVVISI',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'] 
          }
        },
        // {
        //   path: '/clienti/messa-in-mora',
        //   name: 'AskMessaInMoraAll',
        //   component: ViewMessaInMoraAll,
        //   beforeEnter: [hasProfiles],
        //   meta: { 
        //     title: 'MESSA IN MORA',
        //     profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
        //    }
        // },
        {
          path: '/fatture',
          name: 'Fatture Acquisto',
          component: Fatture,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURE ACQUISTO',
            profiles:['all', 'contabilita']
           }
        },
        {
          path: '/fatture-vendita',
          name: 'Fatture Vendita',
          component: FattureVendita,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURE VENDITA',
            profiles:['all', 'contabilita', 'backoffice'] 
          }
        },
        {
          path: '/fatture-scadute-one-year',
          name: 'FattureScaduteOneYear',
          component: FattureScaduteOneYear,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURE SCADUTE',
            profiles: ['all', 'contabilita', 'credito']
          }
        },
        {
          path: '/fatture-vendita-scadute',
          name: 'Fatture Scadute',
          component: FattureScadute,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURE SCADUTE',
            profiles:['all', 'contabilita', 'backoffice', 'credito'] 
          }
        },
        {
          path: '/gestisci-solleciti',
          name: 'Gestisci Solleciti',
          component: GestisciSolleciti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'GESTISCI SOLLECITI',
            profiles:['all', 'contabilita', 'backoffice', 'credito'] 
          }
        },
        {
          path: '/fornitori-dogane',
          name: 'Fornitori Dogane',
          component: FornitoriDogane,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FORNITORI DOGANE',
            profiles:['all', 'contabilita']
           }
        },
        {
          path: '/accise-dogane',
          alias: [
            '/controllo-dogane',
            '/dichiarazioni-dogane',
            '/accise-dogane/annuali',
            '/accise-dogane/semestrali',
            '/accise-dogane/mensili',
            '/accise-dogane/addizionali'
          ],
          name: 'Accise Dogane',
          component: ControlloDogane,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'ACCISE DOGANE',
            profiles:['all', 'contabilita']
           }
        },
        {
          path: '/invii-telematici-dogane',
          name: 'Invii Telematici Dogane',
          component: InviiTelematiciDogane,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'INVII TELEMATICI DOGANE',
            profiles:['all', 'contabilita']
           }
        },
        {
          path: '/bilancio-fatture-acquisto',
          name: 'Bilancio Fatture Acquisto',
          component: BilancioFattureAcquisto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BILANCIO FATTURE ACQUISTO',
            profiles:['all', 'contabilita']
           }
        },
        {
          path: '/bilancio-fatture-fornitori',
          name: 'Bilancio Fatture Fornitori',
          component: BilancioFattureFornitori,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BILANCIO FATTURE FORNITORI',
            profiles:['all', 'contabilita', 'backoffice']
           }
        },
        {
          path: '/controllo-fatture-fornitori/ee',
          name: 'Controllo Fatture Fornitori EE',
          component: ControlloFattureFornitoriEE,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO FATTURE FORNITORI EE',
            profiles:['all', 'contabilita', 'credito']
          }
        },
        {
          path: '/controllo-fatture-fornitori/gas',
          name: 'Controllo Fatture Fornitori GAS',
          component: ControlloFattureFornitoriGAS,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO FATTURE FORNITORI GAS',
            profiles:['all', 'contabilita', 'credito']
          }
        },
        {
          path: '/controllo-acquistato-venduto',
          name: 'Controllo Acquistato e Venduto',
          component: ControlloAcquistatoVenduto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ACQUISTATO/VENDUTO',
            profiles:['all', 'contabilita', 'credito']
          }
        },
        {
          path: '/analisi-fornitori',
          name: 'Analisi Fornitori',
          component: AnalisiFornitori,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ANALISI FORNITORI',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/cmor',
          name: 'Cmor - Messe in mora',
          component: Cmor,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CMOR | MESSE IN MORA',
            profiles:['all','credito', 'backoffice']
          }
        },
        {
          path: '/cmor-invio',
          name: 'Cmor invio',
          component: CmorInvio,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CMOR INVIO',
            profiles:['all','credito']
          }
        },
        {
          path: '/cmor-giornaliere',
          name: 'Cmor giornaliere',
          component: CmorGiornaliere,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CMOR GIORNALIERE',
            profiles:['all','credito']
          }
        },
        {
          path: '/clienti-in-uscita',
          name: 'Clienti In Uscita',
          component: ClientiInUscita,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CLIENTI IN USCITA',
            profiles:['all','pratiche']
          }
        },
        {
          path: '/preavvisi-invio',
          name: 'Preavvisi invio',
          component: PreavvisiInvio,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREAVVISI INVIO',
            profiles:['all','credito']
          }
        },
        {
          path: '/sospensione',
          name: 'Sospensione',
          component: Sospensione,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Sospensione',
            profiles:['all','credito','pratiche','backoffice']
          }
        },
        {
          path: '/preavvisi-sosp-solleciti',
          name: 'Preavvisi Sospensione Solleciti',
          component: PreavvisiSospSolleciti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREAVVISI INVIO',
            profiles:['all','credito', 'assistenza_clienti']
          }
        },

        {
          path: '/sospensioni-riattivazioni-forniture',
          name: 'Sospensioni Riattivazioni',
          component: Sospensione,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Sospensioni Riattivazioni',
            profiles:['all','credito','pratiche','backoffice', 'assistenza_clienti']
          }
        },

        {
          path: '/rilascio-tutela',
          name: 'Rilascio Tutela',
          component: Tutela,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Rilascio Tutela',
            profiles:['all','pratiche','backoffice', 'assistenza_clienti']
          }
        },

        {
          path: '/pun',
          name: 'Pun',
          component: Pun,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PUN',
            profiles:['all', 'admin']
          }
        },
        {
          path: '/tariffe-ee',
          name: 'Tariffe EE',
          component: TariffeEe,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'TARIFFE EE',
            profiles:['all', 'admin','contabilita','credito']
          }
        },
        {
          path: '/tariffe-gas',
          name: 'Tariffe GAS',
          component: TariffeGas,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'TARIFFE GAS',
            profiles:['all', 'admin','contabilita','credito']
          }
        },
        {
          path: '/fattura-voci',
          name: 'Fattura Voci',
          component: FatturaVoci,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FATTURA VOCI',
            profiles:['all', 'credito','contabilita']
          }
        },
        {
          path: '/bonus-basilicata',
          name: 'Bonus Basilicata',
          component: BonusBasilicata,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BONUS BASILICATA',
            profiles:['all', 'credito','credito-light']
          }
        },
        {
          path: '/estratti-conto',
          name: 'Estratti Conto',
          component: EstrattiConto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ESTRATTI CONTO',
            profiles:['all', 'contabilita', 'assistenza_clienti'] 
          }
        },
        {
          path: '/controlli-estratto-banca',
          name: 'Controlli Estratti Conto',
          component: ControlliEstrattoBanca,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'CONTROLLI ESTRATTI CONTO',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        {
          path: '/controllo-pagamenti',
          name: 'Controllo Pagamenti',
          component: ControlloPagamenti,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'CONTROLLO PAGAMENTI',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        {
          path: '/estratti-conto/detail/not-regularized/:id',
          name: 'Estratti Conto Dettagli Non Regolarizzati',
          component: EstrattiContoDetailUnregularized,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'NON REGOLARIZZATO',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        {
          path: '/estratti-conto/detail/regularized/:id',
          name: 'Estratti Conto Dettagli Regolarizzati',
          component: EstrattiContoDetailRegularized,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'REGOLARIZZATO',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        {
          path: '/estratti-conto/detail/:typeNote/not-regularized/:id',
          name: 'Estratti Conto Dettagli Note Non Regolarizzati',
          component: EstrattiContoDetailNoteUnregularized,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'NON REGOLARIZZATO',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        // {
        //   path: '/estratti-conto/detail/:typeNote/regularized/:id',
        //   name: 'Estratti Conto Dettagli Note Regolarizzati',
        //   component: EstrattiContoDetailNoteRegularized
        // },
        {
          path: '/estratti-conto/detail/prev-next/:id',
          name: 'EstrattiConto Prev-Next',
          component: EstrattiContoPrevNext,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREV/NEXT',
            profiles:['all', 'contabilita', 'assistenza_clienti']
          }
        },
        {
          path: '/estratti-conto/gestione-movimenti-ignoti',
          name: 'Gestione Movimenti Ignoti',
          component: GestioneMovimentiIgnoti,
          meta: {
            title: 'GESTIONE MOVIMENTI IGNOTI',
            profiles: []
          }
        },        {
          path: '/controllo-fatture-acquisto',
          name: 'AskControlloFattureAcquisto',
          component: ViewControlloFattureAcquisto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONSUMO FATTURE ACQUISTO',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/statistiche-agyo',
          name: 'AskTesoreriaStatisticheAgyo',
          component: ViewTesoreriaStatisticheAgyo,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'STATISTICHE AGYO',
            profiles:['all', 'contabilita','backoffice']
          }
        },
        {
          path: '/tesoreria/bilancio/saldi',
          name: 'AskTesoreriaBilancioSaldi',
          component: ViewTesoreriaBilancioSaldi,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BILANCIO SALDI',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/codici-iva',
          name: 'AskTesoreriaCodiciIva',
          component: ViewTesoreriaCodiciIva,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CODICI IVA',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/banche-e-codici-conto',
          name: 'AskBancheECodiciConto',
          component: ViewAskBancheECodiciConto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BANCHE E COD. CONTO',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/fornitori/conti-acquisto',
          name: 'AskFornitoriContiAcquisto',
          component: ViewAskFornitoriContiAcquisto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FORNITORI CONTI ACQUISTO',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/elenco-moduli-rid',
          name: 'ViewAskElencoModuliRid',
          component: ViewAskElencoModuliRid,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Moduli RID',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/fornitori/bollo',
          name: 'ViewAskFornitoriBollo',
          component: ViewAskFornitoriBollo,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BOLLO',
            profiles:['all', 'contabilita']
          }
        },
        {
          path: '/tesoreria/mindtab-fornitori',
          name: 'MindtabFornitori',
          component: ViewMindtabFornitori,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'MINDTAB FORNITORI',
            profiles:['all', 'contabilita', 'acquisto']
          }
        },
        {
          path: '/operazioni-massive',
          name: 'Richieste Massive',
          component: OperazioniMassive,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'OPERAZ. MASSIVE',
            profiles:['all', 'backoffice']
          }
        },
        {
          path: '/previsionale-dispacciamento',
          name: 'Previsionale dispacciamento',
          component: PrevisionaleDispacciamento,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREVISIONALE DISPACCIAMENTO',
            profiles:['all', 'backoffice']
          }
        },
        {
          path: '/previsionale-incassi',
          name: 'Previsionale incassi',
          component: PrevisionaleIncassi,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREVISIONALE INCASSI',
            profiles:['all']
          }
        },
        {
          path: '/previsionale-uscite',
          name: 'Previsionale uscite',
          component: PrevisionaleUscite,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREVISIONALE USCITE',
            profiles:['all','contabilita']
          }
        },
       // {
       //   path: '/bilancio',
       //   name: 'Bilancio',
       //   component: Bilancio,
       //   beforeEnter: [hasProfiles],
       //   meta: { 
        //    title: 'BILANCIO',
         //    profiles:['all','contabilita']
         //  }
        // },
        {
          path: '/bonus-sociale',
          name: 'Bonus Sociale',
          component: BonusSociale,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'BONUS SOCIALE',
            profiles:['all', 'backoffice', 'credito']
           }
        },
        {
          path: '/costi-pratiche',
          name: 'Costi Pratiche',
          component: CostiPratiche,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'COSTI PRATICHE',
            profiles:['all', 'backoffice', 'credito']
           }
        },
        {
          path: '/prezzo-acquisto',
          name: 'Prezzo Acquisto',
          component: PrezzoAcquisto,  
          beforeEnter: [hasProfiles], 
          meta: { 
            title: 'PREZZO ACQUISTO',
            profiles:['all', 'pratiche']
           }
        },
        {
          path: '/gestione-pratiche',
          name: 'Gestione Pratiche',
          component: GestionePratiche,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Gestione Pratiche',
            profiles:['all', 'pratiche','backoffice','credito', 'assistenza_clienti']
           }
        },
        {
          path: '/invio-pdc',
          name: 'Invio PDC',
          component: InvioPDC,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Invio PDC',
            profiles:['all', 'pratiche','backoffice','credito']
           }
        },
        {
          path: '/gestione-pdc',
          redirect: '/gestione-pdc/statistiche'
        },
        {
          path: '/gestione-pdc/statistiche',
          name: 'Statistiche PdC',
          component: StatistichePDC,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Statistiche PdC',
            profiles:['all', 'pratiche','backoffice','credito']
          }
        },
        {
          path: '/gestione-pdc/fix',
          name: 'Fix PdC',
          component: FixPDC,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Fix PdC',
            profiles:['all', 'pratiche','backoffice','credito']
          }
        },
        {
          path: '/gestione-pdc/invia',
          name: 'Invia PdC',
          component: InvioPDC,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Invia PdC',
            profiles:['all', 'pratiche','backoffice','credito']
          }
        },
        {
          path: '/gestione-preventivi-pratiche',
          name: 'Gestione Preventivi Pratiche',
          component: GestionePreventiviPratiche,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Gestione Preventivi Pratiche',
            profiles:['all', 'pratiche','backoffice','credito']
           }
        },
        {
          path: '/gestione-pratiche/Cessazione/:id?',
          name: 'Cessazione',
          component: Cessazione,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Cessazione',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/ModificaMc1/:id?',
          name: 'ModificaMc1',
          component: ModificaMc1,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ModificaMc1',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/ModificaPosaContatore/:id?',
          name: 'ModificaPosaContatore',
          component: ModificaPosaContatore,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ModificaPosaContatore',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/PraticaVoltura',
          name: 'PraticaVoltura',
          component: PraticaVoltura,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PraticaVoltura',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/PraticaSubentro',
          name: 'PraticaSubentro',
          component: PraticaSubentro,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PraticaSubentro',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/PraticaVT4',
          name: 'PraticaVT4',
          component: PraticaVT4,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PraticaVT4',
            profiles:['all', 'pratiche', 'assistenza_clienti']
           }
        },
        {
          path: '/gestione-pratiche/InfoPratiche',
          name: 'LogPratiche',
          component: logPratiche,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PraticaVT4',
            profiles:['all', 'pratiche']
           }
        },
        {
          path: '/AutoLettura',
          name: 'AutoLettura',
          component: AutoLettura,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'AutoLettura',
            profiles:['all', 'pratiche','backoffice','credito','contabilita', 'assistenza_clienti']
           }
        },
        {
          path: '/RcuCheck',
          name: 'RcuCheck',
          component: RcuCheck,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RcuCheck',
            profiles:['all', 'pratiche','backoffice','credito', 'assistenza_clienti']
           }
        },
        {
          path: '/check-recessi',
          name: 'Check Recessi',
          component: CheckRecessi,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CHECK RECESSI',
            profiles:['all', 'pratiche']
           }
        },
        {
          path: '/switch-in',
          name: 'Switch-in',
          component: Switchin,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'SWITCH-IN',
            profiles:['all', 'pratiche']
           }
        },
        {
          path: '/switch-in/caricati',
          name: 'Switch-in Caricati',
          component: SwitchinCaricati,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'SWITCH-IN CARICATI',
            profiles:['all', 'pratiche','backoffice']
           }
        },
        {
          path: '/switch-out',
          name: 'Switch-out',
          component: Switchout,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'SWITCH-OUT',
            profiles:['all', 'pratiche', 'backoffice','credito', 'assistenza_clienti']
           }
        },
        {
          path: '/swoutCredito',
          name: 'swoutCredito',
          component: swoutCredito,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'swoutCredito',
            profiles:['all', 'pratiche', 'backoffice','credito','credito_light']
           }
        },
        {
          path: '/previsionale',
          name: 'Previsionale',
          component: Previsionale,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PREVISIONALE',
            profiles:['all', 'pratiche', 'backoffice']
           }
        },
        {
          path: '/controllo-consumi',
          name: 'Controllo Consumi',
          component: ControlloConsumi,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO CONSUMI',
            profiles:['all', 'credito']
          }
        },
        // {
        //   path: '/controllo-rid',
        //   name: 'Controllo Rid',
        //   component: ControlloRid,
        //   beforeEnter: [hasProfiles],
        //   meta: { 
        //     title: 'CONTROLLO RID',
        //     profiles:['all', 'backoffice', 'credito']
        //   }
        // },
        {
          path: '/controllo-storni-rid',
          name: 'Controllo Storni Rid',
          component: ControlloStorniRid,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO STORNI RID',
            profiles:['all', 'backoffice','credito', 'assistenza_clienti']
          }
        },
        {
          path: '/in-call',
          name: 'In Call',
          component: Incall,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'IN CALL',
            profiles:['all', 'contabilita', 'credito', 'backoffice','credito_light', 'assistenza_clienti'] 
          }
        },
         {
          path: '/recupero-credito',
          name: 'Recupero Credito',
          component: RecuperoCredito,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RECUPERO CREDITO',
            profiles:['all', 'contabilita', 'credito', 'backoffice','credito_light'] 
          }
        },
        {
          path: '/CreditoView',
          name: 'CreditoView',
          component: CreditoView,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CreditoView',
            profiles:['all', 'contabilita', 'credito','credito_light'] 
          }
        },
        {
          path: '/credito-da-gestire',
          name: 'Credito Da Gestire',
          component: InfoCreditoDaGestire,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CREDITO DA GESTIRE',
            profiles:['all', 'contabilita', 'credito', 'backoffice','credito_light'] 
          }
        },
        {
          path: '/credito-da-gestire-business',
          name: 'Credito Da Gestire Business',
          component: InfoCreditoDaGestireBusiness,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CREDITO DA GESTIRE BUSINESS',
            profiles:['all', 'contabilita', 'credito', 'backoffice','credito_light'] 
          }
        },
        {
          path: '/info-validazione-credito',
          name: 'Info Validazione Credito',
          component: InfoValidazioneCredito,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'INFO VALIDAZIONE CREDITO',
            profiles:['all','credito'] 
          }
        },
        {
          path: '/riepilogo-mensile-rid',
          name: 'Riepilogo Mensile Rid',
          component: RiepilogoMensileRid,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO MENSILE RID',
            profiles:['all', 'contabilita', 'backoffice'] 
          }
        },
        {
          path: '/riepilogo-mensile-insoluti',
          name: 'Riepilogo Mensile Insoluti',
          component: RiepilogoMensileInsoluti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO MENSILE RID',
            profiles:['all','credito','credito_light', 'assistenza_clienti'] 
          }
        },
        {
          path: '/riepilogo-insoluti-agenti',
          name: 'Riepilogo Insoluti Agenti',
          component: RiepilogoInsolutiAgenti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO INSOLUTI AGENTI',
            profiles:['all','credito','credito_light'] 
          }
        },
        {
          path: '/riepilogo-pagamenti',
          name: 'Riepilogo Pagamenti',
          component: RiepilogoPagamenti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO PAGAMENTI',
            profiles:['all','credito', 'assistenza_clienti'] 
          }
        },
        {
          path: '/riepilogo-provvigioni',
          name: 'Riepilogo Provvigioni',
          component: RiepilogoProvvigioni,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO PROVVIGIONI',
            profiles:['all', 'pratiche'] 
          }
        },
        {
          path: '/riepilogo-gettoni',
          name: 'Riepilogo Gettoni',
          component: RiepilogoGettoni,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'RIEPILOGO GETTONI',
            profiles:['all', 'pratiche','backoffice'] 
          }
        },
        {
          path: '/controllo-voci-fattura',
          name: 'Controllo Voci in Fattura',
          component: ControlloVociFattura,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO VOCI IN FATTURA',
            profiles:['all', 'backoffice', 'assistenza_clienti'] 
          }
        },
        {
          path: '/clienti/note-credito',
          name: 'Controllo Note Credito',
          component: ControlloNoteCredito,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTROLLO NOTE CREDITO',
            profiles:['all', 'credito', 'assistenza_clienti'] 
          }
        },
        {
          path: '/andamento-agenti/:type?/:id?',
          name: 'Andamento Agenti',
          component: AndamentoAgenti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ANDAMENTO AGENTI',
            profiles:['all', 'backoffice','credito'] 
          }
        },
        {
          path: '/non-sospendibili',
          name: 'Non sospendibili',
          component: NonSospendibili,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'NON SOSPENDIBILI',
            profiles:['all','credito']
          }
        },
        {
          path: '/CreditiUsciti',
          name: 'CreditiUsciti',
          component: CreditiUsciti,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CreditiUsciti',
            profiles:['all', 'contabilita', 'credito'] 
          }
        },
        {
          path: '/InfoPraticheDossier',
          name: 'InfoPraticheDossier',
          component: InfoPraticheDossier,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'InfoPraticheDossier',
            profiles:['all', 'contabilita', 'credito'] 
          }
        },
        {
          path: '/InfoCodiciConto',
          name: 'InfoCodiciConto',
          component: InfoCodiciConto,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'InfoCodiciConto',
            profiles:['all', 'contabilita'] 
          }
        },
        {
          path: '/RidSddAllianz',
          name: 'RidSddAllianz',
          component: RidSddAllianz,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Rid Sdd Allianz',
            profiles:['all', 'admin', 'contabilita', 'fatturazione','backoffice']
          }
        },
        {
          path: '/RidSddBanche',
          name: 'RidSddBanche',
          component: RidSddBanche,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Rid Sdd Banche',
            profiles:['all', 'admin', 'contabilita']
          }
        },
        {
          path: '/InfoRichiestaRimborsi',
          name: 'InfoRichiestaRimborsi',
          component: InfoRichiestaRimborsi,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'Info Richiesta Rimborsi',
            profiles: ['all', 'contabilita', 'backoffice', 'credito','fatturazione_light','fatturazione', 'assistenza_clienti'],
          },
        },
        {
          path: '/FatturazioneView',
          name: 'FatturazioneView',
          component: FatturazioneView,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FatturazioneView',
            profiles:['all', 'contabilita', 'credito', 'backoffice', 'assistenza_clienti'] 
          }
        },
        {
          path: '/Fatturazione',
          name: 'Fatturazione',
          component: Fatturazione,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'Fatturazione',
            profiles:['all', 'contabilita', 'credito'] 
          }
        },
        {
          path: '/FatturazioneGas',
          name: 'FatturazioneGas',
          component: FatturazioneGas,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FatturazioneGas',
            profiles:['all', 'contabilita', 'credito'] 
          }
        },
        {
          path: '/CheckNonFatturati',
          name: 'CheckNonFatturati',
          component: CheckNonFatturati,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CheckNonFatturati',
            profiles:['all', 'contabilita', 'credito','fatturazione_light'] 
          }
        },
        {
          path: '/InfoFatturazione',
          name: 'InfoFatturazione',
          component: InfoFatturazione,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'InfoFatturazione',
            profiles:['all', 'contabilita', 'credito'] 
          }
        },
        {
          path: '/FatturazioneExtra',
          name: 'FatturazioneExtra',
          component: FatturazioneExtra,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'FatturazioneExtra',
            profiles:['all', 'contabilita', 'credito','fatturazione_light', 'assistenza_clienti'] 
          }
        },
        {
          path: '/GestioneDepositi',
          name: 'GestioneDepositi',
          component: GestioneDepositi,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'GestioneDepositi',
            profiles:['all', 'contabilita', 'credito','fatturazione_light'] 
          }
        },
        {
          path: '/PreviewFatture',
          name: 'PreviewFatture',
          component: Previewfatture,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PreviewFatture',
            profiles:['all', 'contabilita', 'credito','fatturazione_light','backoffice'] 
          }
        },
  {
          path: '/PreviewFattureGas',
          name: 'PreviewFattureGas',
          component: Previewfatturegas,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'PreviewFatture',
            profiles:['all', 'contabilita', 'credito','fatturazione_light','backoffice'] 
          }
        },
         {
          path: '/ValidazioneFatture',
          name: 'ValidazioneFatture',
          component: ValidazioneFatture,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'ValidazioneFatture',
            profiles: ['all', 'contabilita', 'credito', 'backoffice', 'fatturazione_light']
          },
        },
        
        {
          path: '/contabili',
          name: 'Contabili',
          component: Contabili,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'CONTABILI',
            profiles:['all', 'contabilita', 'credito', 'assistenza_clienti'] 
          }
        },
        {
          path: '/report-pod',
          name: 'Report Pod',
          component: ReportPod,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'REPORT POD',
            profiles:['all', 'credito'] 
          }
        },
        {
          path: '/andamento-cab',
          name: 'Andamento CAB',
          component: AndamentoCab,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'ANDAMENTO CAB',
            profiles:['all'] 
          }
        },
        {
          path: '/info-ticket',
          name: 'Info Ticket',
          component: InfoTicket,
          beforeEnter: [hasProfiles],
          meta: { 
            title: 'INFO TICKET',
            profiles:['all'] 
          }
        },
        {
          path: '/documentazione',
          name: 'Documentazione',
          component: Documentazione,
          beforeEnter: [hasProfiles],
          meta: { title: 'DOCUMENTAZIONE', profiles: ['all'] }
        },
        {
          path: '/pannello-funzionalita',
          name: 'Pannello Funzionalità',
          component: PannelloFunzionalita,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'PANNELLO FUNZIONALITA',
            profiles:['all']
          }
        },
        {
            path: '/preview-fatturato',
            name: 'Preview Fatturato',
            component: PreviewFatturato,
            beforeEnter: [hasProfiles],           
            meta: { 
              title: 'PREVIEW FATTURATO',
              profiles:['all', 'credito']
            }
        },
        {
          path: '/preview-sospensioni-riattivazioni',
          name: 'Preview Sospensioni - Riattivazioni',
          component: PreviewSospensioniRiattivazioni,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'PREVIEW SOSPENSIONI/RIATTIVAZIONI',
            profiles:['all', 'credito', 'backoffice']
          }
        },
        {
          path: '/preview-rilascio-tutela',
          name: 'Preview Rilascio Tutela',
          component: PreviewRilascioTutela,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'PREVIEW RILASCIO TUTELA',
            profiles:['all', 'credito', 'backoffice']
          }
        },
        {
          path: '/sospensioni-riattivazioni',
          name: 'Sospensioni - Riattivazioni',
          component: SospensioniRiattivazioni,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'SOSPENSIONI/RIATTIVAZIONI',
            profiles:['all', 'credito', 'backoffice','pratiche']
          }
        },
        {
          path: '/info-ciclo',
          name: 'Info Ciclo',
          component: InfoCiclo,
          beforeEnter: [hasProfiles],           
          meta: { 
            title: 'INFO CICLO',
            profiles:['all', 'credito', 'contabilita']
          }
        },
        {
          path: '/tickets',
          name: 'Tickets',
          component: Tickets,
          beforeEnter: [hasProfiles],          
          meta: { 
            title: 'TICKETS',
            profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'credito_light', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti']
          },
      },
      {
          path: '/richiesta-ferie',
          name: 'RichiestaFerie',
          component: RichiestaFerie,
          beforeEnter: [hasProfiles],
          meta: {
            title: 'FERIE E PERMESSI',
            profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'credito_light', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti', 'settings', 'validazione', 'fatturazione_light']
          },
      },
      {
        path: '/ftp',
        name: 'Ftp',
        component: Ftp,
        beforeEnter: [hasProfiles],          
        meta: { 
          title: 'Ftp',
          profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
        },
      },
      {
          path: '/impostazioni',
          name: 'Impostazioni',
          component: Impostazioni,
          beforeEnter: [hasProfiles],          
          meta: { 
            title: 'IMPOSTAZIONI',
            profiles:['all', 'settings']
          },
      },
      {
        path: '/permessi',
        name: 'Permessi',
        component: Permessi,
        beforeEnter: [hasProfiles],          
        meta: { 
          title: 'PERMESSI',
          profiles:['all']
        },
      },
      { 
        // return dashboard if uri not found
        path: '/:pathMatch(.*)*', 
        component: Home,
        beforeEnter: [hasProfiles],
        meta: { 
          profiles:['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo']
        },
      },


        //// DEMO PAGES ////////////////////


        // {
        //     path: '/formlayout',
        //     name: 'formlayout',
        //     component: () => import('@/components/FormLayoutDemo.vue'),
        // },
        // {
        //     path: '/input',
        //     name: 'input',
        //     component: () => import('@/components/InputDemo.vue'),
        // },
        // {
        //     path: '/floatlabel',
        //     name: 'floatlabel',
        //     component: () => import('@/components/FloatLabelDemo.vue'),
        // },
        // {
        //     path: '/invalidstate',
        //     name: 'invalidstate',
        //     component: () => import('@/components/InvalidStateDemo.vue'),
        // },
        // {
        //     path: '/list',
        //     name: 'list',
        //     component: () => import('@/components/ListDemo.vue'),
        // },
        // {
        //     path: '/tree',
        //     name: 'tree',
        //     component: () => import('@/components/TreeDemo.vue'),
        // },
        // {
        //     path: '/panel',
        //     name: 'panel',
        //     component: () => import('@/components/PanelsDemo.vue'),
        // },
        // {
        //     path: '/overlay',
        //     name: 'overlay',
        //     component: () => import('@/components/OverlayDemo.vue'),
        // },
        // {
        //     path: '/messages',
        //     name: 'messages',
        //     component: () => import('@/components/MessagesDemo.vue'),
        // },
        // {
        //     path: '/file',
        //     name: 'file',
        //     component: () => import('@/components/FileDemo.vue'),
        // },
        // {
        //     path: '/chart',
        //     name: 'chart',
        //     component: () => import('@/components/ChartDemo.vue'),
        // },
        // {
        //     path: '/misc',
        //     name: 'misc',
        //     component: () => import('@/components/MiscDemo.vue'),
        // },
        // {
        //     path: '/empty',
        //     name: 'empty',
        //     component: () => import('@/components/EmptyPage.vue'),
        // },
         
        ]
    }
];


const router = createRouter({
    // history: createWebHashHistory(),
    history: createWebHistory(),
    routes,
});


function hasProfiles(to, from, next) {
  const profiles  = to.meta.profiles ?? [];
  const userLoggedStorage = localStorage.getItem('user') != null ? JSON.parse(atob(localStorage.getItem('user'))) : null
  
  if (!userLoggedStorage) {
    next()
  } else {
    const userProfile = userLoggedStorage.user[0].profile
    let allowed = profiles.some(profile => profile in userProfile && userProfile[profile] == 1)
    if (allowed) {
      next()
    } else {
      console.log('access:denied-profiles')
      next({ path: '/login' });
    }
  }
}

// trying to access a restricted page + not logged-in redirect to login page
// refresh accessToken when expired
import AuthRefresh from '@/services/auth/auth.refresh'
import Sospensione from '../pages/Sospensione.vue';
import Previewfatturegas from '../components/fatturazione/Previewfatturegas.vue';
import Tutela from '../pages/Tutela.vue';
import ControllaDilazioni from '../components/ask/pages/dilazioni/ControllaDilazioni.vue';

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const userLoggedStorage = localStorage.getItem('user') != null ? JSON.parse(atob(localStorage.getItem('user'))) : null

  if (authRequired) {
    if (userLoggedStorage) {
      let timestamp = new Date().getTime();
      let timestampExpire = userLoggedStorage.expire_at * 1000
      if (timestamp > timestampExpire) {
        AuthRefresh.getNewAccessToken(userLoggedStorage.refreshToken).then(() =>{
          next();
        })
      } else {
        next();
      }

    } else {
      next('/login');
    }
    
  } else {
    next();
  }
    
});

const DEFAULT_TITLE = "ASK-MANAGEMENT";
router.afterEach((to) => {
    document.title = to.meta.title != null ?  "ASK - "+ to.meta.title : DEFAULT_TITLE
});


// refresh accessToken when expired
// import AuthRefresh from '@/services/auth/auth.refresh'

// router.beforeEach((to, from, next) => { //  afterEach ??? beforeEach
//   console.log('entrato-1')
//   const path = to.path
//   if (path != '/login') {
//     console.log('no-login')
//     if (localStorage.getItem('user')) {
//       console.log('ce-local')
//       const userLoggedStorage = JSON.parse(atob(localStorage.getItem('user')));
//       let timestamp = new Date().getTime();
//       let timestampExpire = userLoggedStorage.expire_at * 1000

//       if (timestamp > timestampExpire) {
//           console.log('scaduto')
//           AuthRefresh.getNewAccessToken(userLoggedStorage.refreshToken).then(() =>{
//             next();
//           })
//       } else {
//         console.log('no-scaduto')
//         next();
//       }
//     }else {
//       console.log('non-ce-local')
//       next();
//     }
    
//   } 

// })


export default router;
